module.exports = __webpack_public_path__ + "img/confirm.f47a8538.png";